import React, { useState } from 'react';
import { Tabs, Tab, Box, Paper } from '@mui/material';
import GroupsView from './GroupsView';

const AdmView = () => {
	const [tab, setTab] = useState(0);

	const handleChange = (event: React.SyntheticEvent, newValue: number) => {
		setTab(newValue);
	};
	return (
		<Paper sx={{ width: '100%' }}>
			<Tabs value={tab} onChange={handleChange}>
				<Tab label="Grupos" />
				{/* <Tab label="Tipos" />
				<Tab label="Configurações" /> */}
			</Tabs>

			{tab === 0 && <GroupsView />}
			{tab === 1 && <Box p={2}>Tipos</Box>}
			{tab === 2 && <Box p={2}>Configurações</Box>}
		</Paper>
	);
};

export default AdmView;
